import React from "react";
import TooltipHover from "./TooltipHover";

const CodeIndicators = ({ indicators, ...props }) =>
  (indicators || [])
    .filter(Boolean)
    .map((indicator) => (
      <TooltipHover
        key={`${indicator.id || ""}-${indicator.type}-${
          indicator.column || ""
        }`}
        icon={indicator.icon}
        image={indicator.image}
        tooltip={`Has ${indicator.label}`}
        icon_color={indicator.color}
        {...props}
      />
    ));

export default CodeIndicators;
